import { create } from 'zustand';
import { persist, devtools } from 'zustand/middleware';
import type { SessionState } from '../types/session';

export const useSessionStore = create<SessionState>()(
  devtools(
    persist(
      set => ({
        sessionId: null,
        msisdn: null,
        sessionLoopId: null,
        abandonedCartLoginSent: false,
        upsellPlan: false,
        setSession: ({ sessionId, msisdn }) =>
          set({ sessionId, msisdn }, false, 'setSession'),
        setMsisdn: msisdn => set({ msisdn }, false, 'setMsisdn'),
        setSessionLoopId: sessionLoopId =>
          set({ sessionLoopId }, false, 'setSessionLoopId'),
        setAbandonedCartLoginSent: () =>
          set(
            { abandonedCartLoginSent: true },
            false,
            'setAbandonedCartLoginSent',
          ),
        setUpsellPlan: upsellPlan =>
          set({ upsellPlan }, false, 'setUpsellPlan'),
        clearSession: () =>
          set(
            {
              sessionId: null,
              msisdn: null,
              sessionLoopId: null,
              abandonedCartLoginSent: false,
              upsellPlan: false,
            },
            false,
            'clearSession',
          ),
      }),
      { name: 'session-storage' },
    ),
    { name: 'SessionStore' },
  ),
);
